// This normally-empty utility function is mostly just for clarity. Naming
// something `ignorePromiseFailure` makes it clear that we know that we're
// swallowing errors, and we are relying on another promise subscriber to deal
// with them.
//
// It's also useful to be able to drop some logging, a breakpoint, or a `throw`
// in this function if something weird is happening and we're not sure why.
export default function () {}
